import { render, staticRenderFns } from "./MustKnow.vue?vue&type=template&id=0d4c027f&scoped=true&"
import script from "./MustKnow.vue?vue&type=script&lang=js&"
export * from "./MustKnow.vue?vue&type=script&lang=js&"
import style0 from "./MustKnow.vue?vue&type=style&index=0&id=0d4c027f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c027f",
  null
  
)

export default component.exports